import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from  '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/Global-Services/common.service';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { HttpErrorResponse } from '@angular/common/http';

export interface DialogData {
  FTERecord: any;
  CurrUserGPN: string;
  IsAdmin: any;
  IsPartner: any;
  IsSLHR: any;
}


@Component({
  selector: 'app-pop-up-partner-action-component',
  templateUrl: './pop-up-partner-action-component.component.html',
  styleUrls: ['./pop-up-partner-action-component.component.css'],
  providers: [CommonService],
  standalone: false,
})
export class PopUpPartnerActionComponentComponent implements OnInit {

  ErrorMessage: any[];
  constructor(public dialogRef: MatDialogRef<PopUpPartnerActionComponentComponent>, private _router: Router,
    private gservice: CommonService, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public _data: DialogData, private status: HTTPStatus) { }

  ngOnInit() {



  }


  closeDialog() {
    this.dialog.closeAll();
  }

  ShowLabelContent() {
    if (this._data.FTERecord.ActionType == 'Approve') {
      return 'Approval Comment';
    }
    else if (this._data.FTERecord.ActionType == 'Reject') {
      return 'Reject Reason';
    }
    else if (this._data.FTERecord.ActionType == 'Return') {
      return 'Return Reason';
    }
  }

  UpdatePartnerAction() {
    this.ErrorMessage = [];
    if ((this._data.IsAdmin == true || this._data.IsPartner == true) && this._data.FTERecord.RequestStatusID == Number.parseInt("4")) {
      if (this._data.FTERecord.PartnerComments == null || this._data.FTERecord.PartnerComments == '') {
        this.ErrorMessage.push({ message: 'Please enter Reason.' });
      }
    }

    if ((this._data.IsAdmin == true || this._data.IsSLHR == true) && this._data.FTERecord.RequestStatusID == Number.parseInt("5")) {
      if (this._data.FTERecord.SLHRReturnComments == null || this._data.FTERecord.SLHRReturnComments == '') {
        this.ErrorMessage.push({ message: 'Please enter Reason.' });
      }
    }

    if (this.ErrorMessage.length > 0) {
      return;
    }
    if ((this._data.IsAdmin == true || this._data.IsPartner == true) && this._data.FTERecord.RequestStatusID == Number.parseInt("4")) {

      this.gservice.PostService(this._data.FTERecord, 'FTEDetails/UpdatePartnerAction').subscribe(data => {
        if (this._data.FTERecord.ActionType == 'Approve') {
          this.closeDialog();
          alert('Record Approved Successfully.');
          this._router.navigate(['/View/ViewPendingForApproval/2']);
        }
        if (this._data.FTERecord.ActionType == 'Reject') {
          this.closeDialog();
          alert('Record Rejected Successfully..');
          this._router.navigate(['/View/ViewPendingForApproval/2']);
        }
        if (this._data.FTERecord.ActionType == 'Return') {
          this.closeDialog();
          alert('Record Returned Successfully.');
          this._router.navigate(['/View/ViewPendingForApproval/2']);
        }
        if(data != null && data != "" && data.toLowerCase() != "success")
          {
            alert(data);
            return;
          }
      },
        (err: HttpErrorResponse) => {
          this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gservice.RedirectToErrorPage(2);
        });
    }
    else {
      this.gservice.PostService(this._data.FTERecord, 'FTEDetails/UpdateSLHRAction').subscribe(data => {
        if (this._data.FTERecord.ActionType == 'Return') {
          this.closeDialog();
          alert('Record Returned Successfully.');
          this._router.navigate(['/View/ViewPendingForApproval/3']);
        }
        if(data != null && data != "" && data.toLowerCase() != "success")
          {
            alert(data);
            return;
          }
      },
        (err: HttpErrorResponse) => {
          this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gservice.RedirectToErrorPage(2);
        });
    }
  }
}
